import { MenuList } from '../header-menu.component';

export const MENU_DASHBOARD: MenuList[] = [
  {
    label: 'admin.menu.terms',
    route: '/admin/terms',
  },
];
